import { render, staticRenderFns } from "./CheckoutConfirmacao.vue?vue&type=template&id=2a47a130&scoped=true"
import script from "./CheckoutConfirmacao.vue?vue&type=script&lang=js"
export * from "./CheckoutConfirmacao.vue?vue&type=script&lang=js"
import style0 from "./CheckoutConfirmacao.vue?vue&type=style&index=0&id=2a47a130&prod&scoped=true&lang=css"
import style1 from "./CheckoutConfirmacao.vue?vue&type=style&index=1&id=2a47a130&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a47a130",
  null
  
)

export default component.exports